import React, { useMemo } from "react";
import { PieChart, Pie, Tooltip, ResponsiveContainer, Cell } from "recharts";

const COLORS = [
  "#6F3AFF",
  "#3AA6FF",
  "#28a745",
  "#ffc107",
  "#dc3545",
  "#6c757d",
  "#17a2b8",
  "#6610f2",
];

function formatInt(n) {
  return Number(n || 0).toLocaleString("de-DE");
}

function formatPct(p) {
  return `${(p * 100).toFixed(1)}%`;
}

export default function AllTypesPieCard({ title, data }) {
  const total = useMemo(
    () => (data || []).reduce((sum, d) => sum + Number(d.value || 0), 0),
    [data]
  );

  const sorted = useMemo(() => {
    return [...(data || [])].sort(
      (a, b) => Number(b.value || 0) - Number(a.value || 0)
    );
  }, [data]);

  return (
    <div className="analysis-pie-card">
      <div className="analysis-pie-title">{title}</div>

      <div className="analysis-pie-layout">
        {/* Tortendiagramm */}
        <div className="analysis-pie-chart">
          <ResponsiveContainer width="100%" height="100%">
            <PieChart>
              <Pie
                data={sorted}
                dataKey="value"
                nameKey="name"
                outerRadius="85%"
                label={false}
                isAnimationActive={false}
              >
                {sorted.map((_, idx) => (
                  <Cell key={idx} fill={COLORS[idx % COLORS.length]} />
                ))}
              </Pie>

              <Tooltip
                formatter={(value, name) => {
                  const v = Number(value || 0);
                  const pct = total ? v / total : 0;
                  return [`${formatInt(v)} (${formatPct(pct)})`, name];
                }}
              />
            </PieChart>
          </ResponsiveContainer>
        </div>

        {/* Tortendiagramm */}
        <div className="analysis-pie-legend">
          <div className="pie-legend-grid">
            {sorted.map((d, idx) => {
              const v = Number(d.value || 0);
              const pct = total ? v / total : 0;

              return (
                <div key={d.name} className="pie-legend-item">
                  <span
                    className="pie-legend-color"
                    style={{ background: COLORS[idx % COLORS.length] }}
                  />
                  <div>
                    <div className="pie-legend-name">{d.name}</div>
                    <div className="pie-legend-meta">
                      {formatInt(v)} • {formatPct(pct)}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
}